<script>
import { mapActions, mapGetters } from 'vuex';
import { PAYMENT_TYPES } from '@/modules/constants';

export default {
  name: 'ReservationDetails',
  components: {},
  data() {
    return {
      customerSource: '',
      agb: false,
      newsletter: false,
      post: false,
      PAYMENT_TYPES
    };
  },
  computed: {
    ...mapGetters([
      'invoiceData',
      'prices',
      'formData',
      'priceInfo',
      'customer',
      'errorSend',
      'parentNameFirst',
      'parentNameSecond',
      'fromUrl'
    ])
  },
  methods: {
    ...mapActions([
      'setIsMobileAction',
      'setIsFormDetailsEditAction',
      'postOrderAction',
      'formData',
      'updateInvoiceDataAction',
      'resetStoreAction'
    ]),
    handleSubmit: function() {


    console.log('this.prices.total handleSubmit', this.prices.total);

      if (!this.agb) {
        alert('Bitte die AGB bestätigen');
        return;
      }

      if (!this.post) {
        this.post = true;
        this.$store.commit('SET_ERROR_SEND', false);

        this.postOrderAction(response => {
          this.post = false;

          if (window.browoTracker && window.browoTracker.track) {
            window.browoTracker.track('form_step_viewed', {
              step: 4,
              stepName: 'Bestellung Abgeschlossen - OHNE BEZAHLUNG - Step 4',
              timestamp: new Date().toISOString()
            }, { immediate: true });
          }

          if (response.status) {

            if (typeof window.trackBrowoConversion === 'function') {
              try {
                window.trackBrowoConversion('purchase', this.prices.total || response.price, {
                  orderId: response.orderId,
                  price: response.price,
                  paymentMethod: response.paymentMethod,
                  source: 'order-summary-form',
                  formType: 'Bestellung Halteverbot',
                });
              } catch (e) {
                // Tracker should never block the checkout redirect
              }
            }

            
            if (response.redirectUrl) {
              this.resetStoreAction();
              this.$store.commit('SET_FROM_URL', '');
              window.location.href = response.redirectUrl;
            } else {
              this.$store.commit('SET_ERROR_SEND', true);
            }



            
          } else {
            if (window.browoTracker && window.browoTracker.track) {
            window.browoTracker.track('form_step_viewed', {
              step: 4,
              stepName: 'Bestellung Konnte nicht abgeschlossen werden - Step 4',
              timestamp: new Date().toISOString()
            }, { immediate: true });
          }
            this.$store.commit('SET_ERROR_SEND', true);
          }
        });
      }
    }
  },
  mounted() {


    console.log('this.prices.total', this.prices.total);

    if (this.invoiceData.customerSource) {
      this.customerSource = this.invoiceData.customerSource;
    } else {
      this.updateInvoiceDataAction({
        customerSource: this.customerSource
      });
    }

    this.agb = this.invoiceData.agb ? this.invoiceData.agb : false;
    this.setIsFormDetailsEditAction(false);
    this.setIsMobileAction();

    if (typeof PAYPAL === 'undefined') {
      let pppInit = document.createElement('script');
      pppInit.setAttribute('src', 'https://www.paypalobjects.com/webstatic/ppplus/ppplus.min.js');
      document.head.appendChild(pppInit);
    }
  }
};
</script>
<template>
  <div>
    <div class="col-lg-7 col-md-6 col-sm-7 step3-right" style="color: #47B1E5">
      <div>
        <form id="vwo-hv-form-step-3" data-tracking-id="HV_GCLID_FORM3" @submit.prevent>
          <div class="mt-15 mb-15" id="edit-header">
            <strong> <i class="fa fa-check"></i> Ihre Bestelldaten </strong>
          </div>

          <div class="mb-15">
            <div class="row">
              <div class="col-xs-9">
                <strong v-if="formData.secondFormEnabled && formData.secondForm && formData.secondForm.zipCode"
                  >Halteverbotszone 1:</strong
                >
                <strong v-else>Halteverbotszone:</strong>

                <div>{{ formData.street }} {{ formData.streetNr }}, {{ formData.zipCode }} / {{ priceInfo.stadt }}</div>
                <div v-if="parentNameFirst">({{ parentNameFirst }})</div>
              </div>
              <div class="col-xs-3" v-if="!customer || (customer && !customer.bsr && !customer.kuchenaktuell)">
                <strong class="pull-right hide-price"> {{ prices && prices.basePrice | customMoneyFormat }} € </strong>
              </div>
            </div>
          </div>

          <div class="mb-15">
            <div>
              <strong>Datum und Uhrzeiten:</strong>
              <div>
                {{ formData.dateFrom }} bis {{ formData.dateTo }}, <br />
                {{ formData.timeStart ? formData.timeStart : '07:00' }} Uhr bis
                {{ formData.timeEnd ? formData.timeEnd : '17:00' }} Uhr
              </div>
            </div>
            <div v-if="!customer || (customer && !customer.bsr && !customer.kuchenaktuell)">
              <div v-if="!('specific_prices' in prices)">
                <div v-if="prices && prices.days >= 1">
                  <div class="row">
                    <div class="col-xs-9 pr-0">
                      <strong
                        >Zuschlag für Zusatztag pro Tag {{ prices.dailySurcharge }} € x {{ prices.days }} Tag(e)</strong
                      >
                    </div>
                    <div class="col-xs-3">
                      <strong class="hide-price pull-right"
                        >{{ (prices.dailySurcharge * prices.days) | customMoneyFormat }} €</strong
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="mb-15">
            <div>
              <strong>Länge:</strong>
              <span> {{ formData.length }} Meter</span>
            </div>
            <div v-if="!customer || (customer && !customer.bsr && !customer.kuchenaktuell)">
              <div v-if="!('specific_prices' in prices)">
                <div v-if="prices && prices.lengthSurcharge > 0">
                  <strong
                    >Zuschlag für Extralänge pro Tag {{ prices.lengthSurcharge }} € x
                    {{ prices.days + 1 }} Tag(e)</strong
                  >
                  <strong class="pull-right hide-price">
                    {{ (prices.lengthSurcharge * (prices.days + 1)) | customMoneyFormat }} €
                  </strong>
                  <br />
                </div>
              </div>
            </div>
          </div>
          <div v-if="formData.oppositeStreet" class="row mb-15">
            <div class="col-xs-9 pr-0">
              <span>Gegenüberliegende Straßenseite sperren:</span>
            </div>
            <div class="col-xs-3" v-if="!customer || (customer && !customer.bsr && !customer.kuchenaktuell)">
              <div v-if="!('specific_prices' in prices)">
                <strong class="hide-price pull-right"
                  >{{ priceInfo.beidseitig_aufstellung | customMoneyFormat }} €</strong
                >
              </div>
            </div>
          </div>
          <div v-if="!customer || (customer && !customer.bsr && !customer.kuchenaktuell)">
            <div v-if="!('specific_prices' in prices)">
              <div v-if="formData.oppositeStreet && prices && prices.days >= 1">
                <div class="row">
                  <div class="col-xs-9 pr-0">
                    <strong
                      >Zuschlag für Zusatztag pro Tag {{ priceInfo.beidseitig_aufstellung_zuschlag }} € x
                      {{ prices.days }} Tag(e)</strong
                    >
                  </div>
                  <div class="col-xs-3">
                    <strong class="hide-price pull-right"
                      >{{ (priceInfo.beidseitig_aufstellung_zuschlag * prices.days) | customMoneyFormat }} €</strong
                    >
                  </div>
                </div>
                <br />
              </div>
            </div>
          </div>

          <div class="mb-15">
            <strong>Grund der Aufstellung: </strong><span> {{ formData.reason }}</span>
            <br />
          </div>

          <div v-if="!customer || (customer && !customer.bsr && !customer.kuchenaktuell)">
            <div v-if="prices && prices.netPrice" class="mb-15 hide-price" style="font-size: 17px">
              <strong v-if="formData.secondFormEnabled && formData.secondForm && formData.secondForm.zipCode"
                >Halteverbotszone 1 Zwischensumme:
              </strong>
              <strong v-else>Halteverbotszone Zwischensumme: </strong>
              <strong class="pull-right">{{ prices.firstFormPrice | customMoneyFormat }} €</strong>
              <div class="clear"></div>
              <span style="color: #090505;font-size: 12px" class="pull-right">
                (Netto: {{ prices.netPrice | customMoneyFormat }} €)
              </span>
              <div class="clear"></div>
            </div>
          </div>

          <hr style="border-color: #ccc;" />
          <div v-if="formData.secondFormEnabled && formData.secondForm && formData.secondForm.zipCode">
            <div class="mb-15">
              <div class="row">
                <div class="col-xs-9">
                  <strong>Halteverbotszone 2:</strong>
                </div>
                <div class="col-xs-3" v-if="!customer || (customer && !customer.bsr && !customer.kuchenaktuell)">
                  <strong class="pull-right hide-price">
                    {{ prices && prices.secondForm && prices.secondForm.basePrice | customMoneyFormat }} €
                  </strong>
                </div>
              </div>

              <div>
                {{ formData.secondForm.street }} {{ formData.secondForm.streetNr }}, {{ formData.secondForm.zipCode }} /
                {{ priceInfo.secondFormPrice.stadt }}
              </div>
              <div v-if="parentNameSecond">({{ parentNameSecond }})</div>
            </div>
            <div class="mb-15">
              <strong>Datum und Uhrzeiten:</strong><br />
              <div>
                {{ formData.secondForm.dateFrom }} bis {{ formData.secondForm.dateTo }}, <br />
                {{ formData.secondForm.timeStart ? formData.secondForm.timeStart : '07:00' }} Uhr bis
                {{ formData.secondForm.timeEnd ? formData.secondForm.timeEnd : '17:00' }} Uhr <br />
              </div>
              <div v-if="!customer || (customer && !customer.bsr && !customer.kuchenaktuell)">
                <div v-if="!('specific_prices' in prices)">
                  <div v-if="prices && prices.secondForm && prices.secondForm.days > 0" class="row hide-price">
                    <div class="col-xs-10">
                      <strong
                        >Zuschlag für Zusatztag pro Tag {{ prices.secondForm.dailySurcharge }} € x
                        {{ prices.secondForm.days }} Tag(e)</strong
                      >
                    </div>
                    <div class="col-xs-2">
                      <strong class="hide-price pull-right"
                        >{{ (prices.secondForm.dailySurcharge * prices.secondForm.days) | customMoneyFormat }} €</strong
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-15">
              <div>
                <strong>Länge:</strong>
                <span> {{ formData.secondForm.length }} Meter</span>
              </div>
              <div v-if="!customer || (customer && !customer.bsr && !customer.kuchenaktuell)">
                <div v-if="prices && prices.secondForm && prices.secondForm.lengthSurcharge > 0">
                  <strong
                    >Zuschlag für Extralänge pro Tag {{ prices.secondForm.lengthSurcharge }} € x
                    {{ prices.secondForm.days + 1 }} Tag(e)</strong
                  >
                  <strong class="pull-right hide-price">
                    {{ (prices.secondForm.lengthSurcharge * (prices.secondForm.days + 1)) | customMoneyFormat }} €
                  </strong>
                </div>
              </div>
            </div>

            <div class="mb-15">
              <div
                v-if="prices && prices.secondForm && prices.secondForm.days === 0 && formData.secondForm.oppositeStreet"
                class="row"
              >
                <div class="col-xs-9 pr-0">
                  <span id="options_I">Gegenüberliegende Straßenseite sperren:</span>
                </div>
                <div class="col-xs-3" v-if="!customer || (customer && !customer.bsr && !customer.kuchenaktuell)">
                  <div v-if="!('specific_prices' in prices)">
                    <strong class="hide-price pull-right"
                      >{{ prices.secondForm.oppositeSurcharge | customMoneyFormat }} €</strong
                    >
                  </div>
                </div>
              </div>

              <div
                v-if="prices && prices.secondForm && prices.secondForm.days > 0 && formData.secondForm.oppositeStreet"
                class="row"
              >
                <div class="col-xs-9 pr-0">
                  <span>Gegenüberliegende Straßenseite sperren:</span>
                </div>
                <div class="col-xs-3" v-if="!customer || (customer && !customer.bsr && !customer.kuchenaktuell)">
                  <div v-if="!('specific_prices' in prices)">
                    <strong class="hide-price pull-right"
                      >{{ priceInfo.secondFormPrice.beidseitig_aufstellung | customMoneyFormat }} €</strong
                    >
                  </div>
                </div>
              </div>
              <div v-if="!customer || (customer && !customer.bsr && !customer.kuchenaktuell)">
                <div v-if="!('specific_prices' in prices)">
                  <div v-if="formData.secondForm.oppositeStreet && prices && prices.secondForm.days > 0">
                    <div class="row">
                      <div class="col-xs-9 pr-0">
                        <strong
                          >Zuschlag für Zusatztag pro Tag
                          {{ priceInfo.secondFormPrice.beidseitig_aufstellung_zuschlag }} € x
                          {{ prices.secondForm.days }} Tag(e)</strong
                        >
                      </div>
                      <div class="col-xs-3">
                        <strong class="hide-price pull-right"
                          >{{
                          (priceInfo.secondFormPrice.beidseitig_aufstellung_zuschlag * prices.secondForm.days)
                          | customMoneyFormat
                        }}
                          €</strong
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-15" v-if="formData.secondForm && formData.secondForm.reason">
              <strong>Grund der Aufstellung: </strong><span> {{ formData.secondForm.reason }}</span>
            </div>

            <div v-if="!customer || (customer && !customer.bsr && !customer.kuchenaktuell)">
              <div
                v-if="prices && prices.secondForm && prices.secondForm.secondFormPrice"
                class="mb-15 hide-price"
                style="font-size: 17px"
              >
                <strong>Halteverbotszone 2 Zwischensumme: </strong>
                <strong class="pull-right ">{{ prices.secondForm.secondFormPrice | customMoneyFormat }} €</strong>
                <div class="clear"></div>
                <span style="color: #090505;font-size: 12px" class="pull-right">
                  (Netto: {{ prices.secondForm.netPrice | customMoneyFormat }} €)
                </span>
                <div class="clear"></div>
              </div>
            </div>
          </div>

          <div v-if="formData.paymentMethod == 'PayPal'">
            <hr style="border-color: #ccc;" />
            <div class="row">
              <div class="col-xs-9">
                <strong>PayPal-Gebühren:</strong>
              </div>
              <div class="col-xs-3">
                <strong class="pull-right hide-price"
                  >{{ this.calculatePaypalFee(prices) | customMoneyFormat }} €
                </strong>
              </div>
            </div>
          </div>
          <div v-else-if="formData.paymentMethod == 'Sofortüberweisung'">
            <hr style="border-color: #ccc;" />
            <div class="row">
              <div class="col-xs-9">
                <strong>Klarna-Gebühren:</strong>
              </div>
              <div class="col-xs-3">
                <strong class="pull-right hide-price"
                  >{{ this.calculateKlarnaFee(prices) | customMoneyFormat }} €
                </strong>
              </div>
            </div>
          </div>

          <div v-if="prices.coupon.active">
            <hr style="border-color: #ccc;" />
            <div class="row">
              <div class="col-xs-9">
                <strong>Gutschein ({{ prices.coupon.code }}):</strong>
              </div>
              <div class="col-xs-3">
                <strong class="pull-right hide-price">-{{ prices.coupon.discount | customMoneyFormat }} € </strong>
              </div>
            </div>
          </div>

          <div v-if="!customer || (customer && !customer.bsr && !customer.kuchenaktuell)">
            <hr />
            <div v-if="prices && prices.netPrice" class="mb-15" style="font-size: 20px">
              <div class="row hide-price">
                <div class="col-xs-8">
                  <strong>Gesamtpreis:</strong>
                </div>
                <div class="col-xs-4">
                  <strong class="pull-right"> {{ prices.total | customMoneyFormat }} € </strong>
                  <br />
                  <span style="color: #090505; font-size: 12px" class="pull-right">
                    (Netto: {{ prices.totalNet | customMoneyFormat }} €)
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="mt-15 order-button" v-if="!customer || (customer && !customer.bsr && !customer.kuchenaktuell)">
            <hr />
            <label>
              <strong>Wie sind Sie auf uns aufmerksam geworden? (Optional)</strong>
              <select
                v-model="customerSource"
                @change="
                updateInvoiceDataAction({
                  customerSource: customerSource
                })
                "
                class="form-control width-100 mt-5"
                name="customer_source"
              >
                <option value="">Bitte Wählen</option>
                <option value="schilder-gesehen">Sie haben unsere Schilder gesehen</option>
                <option value="einkaufaktuell">EINKAUF AKTUELL</option>
                <option value="radio">Radio</option>
                <option value="plakatwerbung">Plakatwerbung</option>
                <option value="ubahnwerbung">U-Bahn Werbung</option>
                <option value="taxiwerbung">Taxiwerbung</option>
                <option value="printmedien">Printmedien</option>
                <option value="empfehlung">Empfehlung</option>
                <option value="suchmaschine">Suchmaschine</option>
                <option value="internet">Internet / Bannerwerbung</option>
                <option value="suchmaschine">Sonstiges</option>
              </select>
            </label>
          </div>
        </form>
      </div>

      <div class="mt-15 order-button">
        <hr />

        <div>
          <input
            name="agb"
            id="agb"
            type="checkbox"
            :checked="invoiceData.agb || false"
            v-on:change="
            agb = !agb;
          updateInvoiceDataAction({
            agb: agb
          });
            "
          />
          <label id="agb-text" for="agb" style="display: inline; color: #666">
            Ich habe die <a target="_blank" href="agb.html">AGB</a> und die
            <a target="_blank" href="datenschutz.html">Datenschutzbestimmungen</a> gelesen und akzeptiert
          </label>
        </div>

        <br />

        <div v-if="!customer || (customer && !customer.bsr && !customer.kuchenaktuell)">
          <input
            :checked="invoiceData.newsletter || false"
            v-on:change="
            newsletter = !newsletter;
          updateInvoiceDataAction({
            newsletter: newsletter
          });
            "
            name="newsletter"
            id="newsletter"
            type="checkbox"
            value="1"
          />
          <label for="newsletter" style="display: inline; color: #666">
            <span class="b2c_newsletter">Für Newsletter eintragen und von exklusiven Umzugstipps profitieren.</span>
          </label>
        </div>

        <div class="alert alert-danger mt-30 mb-0" role="alert" v-if="errorSend">
          <p>Ein unerwarteter Fehler ist aufgetreten. Bitte kontaktieren Sie unseren Support.</p>
        </div>

        <input
          v-if="!post"
          v-on:click="handleSubmit()"
          id="form-submit"
          type="submit"
          name="form_send_2"
          class="send_btn_III btn btn-danger width-100 mt-20"
          value="Kostenpflichtig Bestellen"
        />
        <input
          v-if="post"
          id="form-submit2"
          type="submit"
          name="form_send_2"
          class="send_btn_III btn width-100 mt-20"
          value="Einen Moment Bitte..."
        />
      </div>
    </div>
  </div>
</template>
<style lang="scss">
@import 'ReservationDetailsStyles';
</style>
